"use client";

import { cn } from "@/lib/utils";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { motion } from "motion/react";
import { memo } from "react";

import { Button } from "@/components/ui/button";

import { setFilters } from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import { selectSearchStatus } from "../../state/selectors";

const tabs = [
  { id: "CHEAPEST", label: "Cheapest" },
  { id: "SHORTEST", label: "Shortest" },
  { id: "EARLIEST", label: "Earliest" },
];

const FlightSortTabs = memo(() => {
  const dispatch = useAppDispatch();

  const { error } = useAppSelector(selectSearchStatus);
  const selectOption = useAppSelector(
    (state) => state.extractFlightFilter.selectOption,
  );
  const changeTab = (value: "CHEAPEST" | "SHORTEST" | "EARLIEST") => {
    if (selectOption.type === value) return;
    dispatch(setFilters({ type: value }));
  };

  return (
    <div className=" flex flex-1 gap-2 pt-3  px-4 rounded-md">
      {tabs.map((tab) => {
        const isActive = selectOption.type === tab.id;

        return (
          <Button
            disabled={error}
            variant={isActive ? "default" : "outline"}
            key={tab.id}
            onClick={() =>
              changeTab(tab.id as "CHEAPEST" | "SHORTEST" | "EARLIEST")
            }
            className={cn(
              "relative z-10 flex-1 py-2 text-sm font-medium rounded-sm  cursor-pointer ",
            )}
          >
            {isActive && (
              <motion.div
                layoutId="tab-indicator"
                className="absolute inset-0 bg-primary rounded-sm z-[1] shadow-sm"
                transition={{
                  type: "spring",
                  stiffness: 400,
                  damping: 50,
                }}
              />
            )}
            <span className={cn("transition-colors duration-200 z-10")}>
              {tab.label}
            </span>
          </Button>
        );
      })}
    </div>
  );
});

FlightSortTabs.displayName = "TopFilter";

export default FlightSortTabs;
